export { PaymentDocumentsRegistryHeader } from './components';
export { PaymentDocumentsRegistry } from './ui';
